import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  BonusPeriodDeleteInput,
  BonusPeriodModel,
  BonusPeriodMutationInput,
  BonusPeriodUpdateInput,
} from './model';

const ENDPOINT = 'bonus-periods';

export function useCreateBonusPeriod(
  options?: UseMutationOptions<
    ApiResult<BonusPeriodModel>,
    ApiError,
    BonusPeriodMutationInput
  >,
) {
  return useMutation<
    ApiResult<BonusPeriodModel>,
    ApiError,
    BonusPeriodMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: ENDPOINT,
      method: 'POST',
      body,
      classType: BonusPeriodModel,
    });
  }, options);
}

export function useUpdateBonusPeriod(
  options?: UseMutationOptions<
    ApiResult<BonusPeriodModel>,
    ApiError,
    BonusPeriodUpdateInput
  >,
) {
  return useMutation<
    ApiResult<BonusPeriodModel>,
    ApiError,
    BonusPeriodUpdateInput
  >(async function ({ body, id }) {
    return await MutationFetchFunction({
      url: `${ENDPOINT}/${id}`,
      method: 'PUT',
      body,
      classType: BonusPeriodModel,
    });
  }, options);
}

export function useDeleteBonusPeriod(
  options?: UseMutationOptions<
    ApiResult<{ message: string }>,
    ApiError,
    BonusPeriodDeleteInput
  >,
) {
  return useMutation<
    ApiResult<{ message: string }>,
    ApiError,
    BonusPeriodDeleteInput
  >(async function ({ id }) {
    return await MutationFetchFunction({
      url: `${ENDPOINT}/${id}`,
      method: 'DELETE',
    });
  }, options);
}
